import React from 'react';
import IconBase from 'react-icons/IconBase';

export const StarIcon = props => (
  <IconBase viewBox="0 0 32 32" {...props}>
    <path
      d="M15.2314 0.585613C15.4733 -0.195204 16.5267 -0.195205 16.7686 0.585612L19.9917 10.9884C20.0998 11.3376 20.4101 11.574 20.7602 11.574H31.1903C31.9732 11.574 32.2987 12.6246 31.6653 13.1072L23.2272 19.5364C22.944 19.7522 22.8255 20.1348 22.9336 20.484L26.1567 30.8868C26.3986 31.6676 25.5465 32.3169 24.9131 31.8343L16.475 25.405C16.1918 25.1892 15.8082 25.1892 15.525 25.405L7.08689 31.8343C6.45354 32.3169 5.60137 31.6676 5.84328 30.8868L9.06635 20.484C9.17454 20.1348 9.05602 19.7522 8.77278 19.5364L0.334677 13.1072C-0.298674 12.6246 0.0268239 11.574 0.809689 11.574H11.2398C11.5899 11.574 11.9002 11.3376 12.0083 10.9884L15.2314 0.585613Z"
      fill="white"
    />
  </IconBase>
);
